import type { PlatformUserApiResponse, TenantSettings, UserSettings } from '@/stores/auth'
import { demoApi } from './db'

export const settingsApi = {
	getUserSettings: async (): Promise<UserSettings> => {
		const response = await demoApi.get<PlatformUserApiResponse & { settings?: UserSettings }>('/me')
		return response.settings || ({} as UserSettings)
	},
	updateUserSettings: async (settingBody: {
		settings: UserSettings
	}): Promise<UserSettings> => demoApi.put('/me/settings', settingBody),
	updateTenantSettings: async (settingBody: {
		settings: TenantSettings
	}): Promise<TenantSettings> => demoApi.put('/me/tenant/settings', settingBody),
}
